import React from 'react';
import { Link } from 'react-router-dom';
import './services-home.styles.scss';

const ServicesHome = () => {
  return (
    <div className="services-home">
      <section className="services-hero">
        <div className="container">
          <h1>Remote Database Administration Services</h1>
          <p>Professional database management solutions for MySQL, PostgreSQL, SQL Server, Oracle, and MongoDB</p>
        </div>
      </section>

      <section className="services-detailed">
        <div className="container">
          <div className="service-category">
            <div className="service-header">
              <div className="service-icon">🗄️</div>
              <h2>Remote Database Administration</h2>
              <p>Professional database management services for all major database platforms</p>
            </div>
            
            <div className="service-offerings">
              <div className="offering-grid">
                <Link to="/services/database/management" className="offering-card">
                  <h3>Database Management</h3>
                  <p>Complete database administration including monitoring, maintenance, and optimization</p>
                  <ul>
                    <li>Performance tuning</li>
                    <li>Backup & recovery</li>
                    <li>Security management</li>
                    <li>24/7 monitoring</li>
                  </ul>
                </Link>
                
                <Link to="/services/database/design" className="offering-card">
                  <h3>Database Design</h3>
                  <p>Strategic database architecture and design for optimal performance</p>
                  <ul>
                    <li>Schema design</li>
                    <li>Data modeling</li>
                    <li>Normalization</li>
                    <li>Indexing strategy</li>
                  </ul>
                </Link>
                
                <Link to="/services/database/coding" className="offering-card">
                  <h3>Database Development</h3>
                  <p>Custom database solutions and stored procedure development</p>
                  <ul>
                    <li>Stored procedures</li>
                    <li>Triggers & functions</li>
                    <li>Data migration</li>
                    <li>API development</li>
                  </ul>
                </Link>
                
                <Link to="/services/database/reporting" className="offering-card">
                  <h3>Database Reporting</h3>
                  <p>Business intelligence and reporting solutions</p>
                  <ul>
                    <li>Custom reports</li>
                    <li>Dashboard creation</li>
                    <li>Data analytics</li>
                    <li>KPI tracking</li>
                  </ul>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Ready to Transform Your IT Infrastructure?</h2>
          <p>Get started with our AI-powered solutions and expert technology services</p>
          <Link to="/contact" className="cta-button">Schedule Executive Consultation</Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesHome;
